import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "../lib/utils";

export const Route = createFileRoute("/activate")({
  head: () => pageHead("page.activate"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    if (!context.auth?.user) {
      throw redirect({ to: "/sign-in" });
    }
    // Already active — skip activation
    if (context.auth.orgId != null) {
      throw redirect({ to: "/" });
    }
  },
});
